export const areElementsIntersecting = (elementOne: HTMLElement, elementTwo: HTMLElement): boolean => {
    const elementOneRect = elementOne.getBoundingClientRect();
    const elementTwoRect = elementTwo.getBoundingClientRect();
    const noIntersection =
        elementOneRect.right <= elementTwoRect.left ||
        elementOneRect.left >= elementTwoRect.right ||
        elementOneRect.bottom <= elementTwoRect.top ||
        elementOneRect.top >= elementTwoRect.bottom;

    return !noIntersection;
};

export const isTouchEvent = (event: React.MouseEvent | React.TouchEvent): boolean => {
    return event?.type?.includes("touch");
};
